import React from 'react';
import "./Banner.scss"
import { useAnimateOnScroll } from '../../Utils/hooks/useAnimateOnScroll';

import bannerImage from "../../Assets/images/home-banner.png";
import ServiceCards from '../ServiceCards/ServiceCards';
import StandardsSection from '../StandardsSection/StandardsSection';
import LoadVisibility from '../LoadVisibility/LoadVisibility';
import TransparencyGuarantee from '../TransparencyGuarantee/TransparencyGuarantee';

const bannerData = {
  badge: "Now Serving the GTA",
  headingLine1: "Ontario\u2019s Digital",
  headingLine2: "Marketplace for",
  headingHighlight: "Heavy Hauling",
  description:
    "Connecting WSIB-verified carriers with Ontario contractors - powered by a transparent 5% flat fee.",
  stats: [
    { value: "5%", label: "FLAT FEE" },
    { value: "WSIB", label: "VERIFIED" },
    { value: "GTA", label: "COVERAGE" },
  ],
};

const Banner = ({ onSignUpClick }) => {
  const bannerRef = useAnimateOnScroll();

  return (
  <main className="home-main">
    <section className="main-wraper banner-cvr">
      <img className="bg-image" src={bannerImage} alt="Background" />
      <div className="banner-content">
        <div className="container">
        <div ref={bannerRef} className="banner-inner left-in">
          <span className="banner-badge">{bannerData.badge}</span>
          <h1>
            {bannerData.headingLine1}
            <br />
            {bannerData.headingLine2}
            <br />
            <span className="text-highlight">{bannerData.headingHighlight}</span>
          </h1>
          <p>{bannerData.description}</p>
          <div className="banner-stats">
            {bannerData.stats.map((stat, index) => (
              <React.Fragment key={index}>
                {index > 0 && <div className="stat-divider" />}
                <div className="banner-stat-item">
                  <span className="stat-value">{stat.value}</span>
                  <span className="stat-label">{stat.label}</span>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
        </div>
      </div>
    </section>
    <ServiceCards onSignUpClick={onSignUpClick} />
    <StandardsSection />
    <LoadVisibility />
    <TransparencyGuarantee />
  </main>
  );
};

export default Banner;
